module.exports = __webpack_public_path__ + "img/Logo-19.5ef48dea.svg";